module.exports = __webpack_public_path__ + "static/media/office-building.57f20bcc.svg";